import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetUser } from '../services/Users/GetUser';
import { GetUserSetting } from '../services/Users/GetUserSetting';
import { CreateUserSetting } from '../services/Users/CreateUserSetting';
import { UpdateUserSettingLanguage } from '../services/Users/UpdateUserSettingLanguage';
import { GetUserInfoInterface } from '../types/getUserInfoInterface';

export const useUserInfoStore = defineStore('userInfo', () => {
  const userInfo = ref<GetUserInfoInterface>({
    id: null,
    userName: '',
    firstName: '',
    lastName: '',
    profileImageUrl: '',
    defaultProfileImageUrl: '',
    dashboardType: null,
    employeeStatus: null,
    securityGroupId: null, // AccessLevelId
    hasInsight: false,
    hasPulse: false,
    hasAnything: false,
    isOrgChartVisible: false,
    biometricId: null,
    companyId: null,
  });

  const getUser = async () => {
    const response = await GetUser();

    userInfo.value = response;
  };
  const getUserResponse = async () => {
    const response = await GetUser();

    return response;
  };


  const getUserSettings = async () => {
    const response = await GetUserSetting(userInfo.value.id);
    return response;
  };

  const createUserSettings = async (settings: any) => {
    const response  = await CreateUserSetting(userInfo.value.id, settings);
    return response;
  }

  const updateUserSettings = async (settings: any) => {
    const response  = await UpdateUserSettingLanguage(userInfo.value.id, settings);
    return response;
  }

  return {
    userInfo,
    getUser,
    getUserResponse,
    getUserSettings,
    createUserSettings,
    updateUserSettings
  };
});
